import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setAlert } from 'actions/alerts';
import api from 'utils/api';
import downloadBlob from 'utils/file/downloadBlob';
import { Menu, MenuButton, MenuList, MenuItem } from 'components/Menu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FORMATS = ['srt', 'docx'];
function DownloadTranscriptMenu(_ref) {
  var meetingId = _ref.meetingId,
    userId = _ref.userId,
    fileName = _ref.fileName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDownloading = _useState2[0],
    setIsDownloading = _useState2[1];
  function download(_x) {
    return _download.apply(this, arguments);
  }
  function _download() {
    _download = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(format) {
      var blob, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsDownloading(true);
            _context.prev = 1;
            _context.next = 2;
            return api('get', "/api/userAnalysis/meeting/".concat(meetingId, "/transcript"), {
              userId: userId,
              format: format
            }, undefined, 'blob');
          case 2:
            blob = _context.sent;
            downloadBlob(blob, "".concat(fileName, ".").concat(format));
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            setAlert({
              title: t('alert_download_failed_title'),
              message: t('error_500')
            });
          case 4:
            _context.prev = 4;
            setIsDownloading(false);
            return _context.finish(4);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }));
    return _download.apply(this, arguments);
  }
  return (
    /*#__PURE__*/
    // Opens upwards, as it sits in the modal's footer at the bottom of the screen
    _jsxs(Menu, {
      menuPlacement: "top-start",
      children: [/*#__PURE__*/_jsx(MenuButton, {
        variant: "default",
        icon: "download",
        iconRight: "chevron",
        isLoading: isDownloading,
        children: t('actions_download')
      }), /*#__PURE__*/_jsx(MenuList, {
        children: FORMATS.map(function (format) {
          return /*#__PURE__*/_jsx(MenuItem, {
            onClick: function onClick() {
              return download(format);
            },
            children: format.toUpperCase()
          }, format);
        })
      })]
    })
  );
}
export default DownloadTranscriptMenu;